module.exports = __webpack_public_path__ + "static/img/homepage-header-aphromoo_v3.90de612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner/homepage-header-aphromoo_v3.jpg
// module id = B9EF
// module chunks = 38